<ng-container *transloco="let t">
    @for (error of mappedErrors; track $index; let isFirst = $first) {
        @if (!onlyRenderFirstError || isFirst) {
            <div class="text-redesign-danger-600 dark:text-redesign-danger-300">
                {{ t(error.message.i18nKey, error.message.params) }}
            </div>
        }
    }
</ng-container>
